/**
 * @file paddlegan 混合模型
 * @author FengGuang(fengguang01@baidu.com)
 */

import PaddleGan from './PaddleGan';
import './style.less';

export default PaddleGan;
